class LoginController {
  constructor() {

  }
}

export default LoginController;
